export default "__VITE_ASSET__9b532ec9__"